import { Box } from '@mui/material';
import Icon from '../../../icon/Icon';
import GaTracker from '../../../../utils/GaTracker/GaTracker';

export default function DealerMarker({
  isSelected,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: {
  isSelected?: boolean;
  lat: number;
  lng: number;
  label: string;
  onClick: () => void;
  onMouseEnter: () => void;
  onMouseLeave?: () => void;
}) {
  return (
    <Box
      onClick={() => {
        GaTracker.trackEvent({
          category: 'MapMarker',
          action: 'click-dealer-map-marker',
          label: 'DealerMarker',
        });
        onClick?.();
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      sx={{
        opacity: isSelected ? 1 : 0.85,
        height: '24px',
        width: '24px',
      }}
    >
      <Icon variant="dealerPin" />
    </Box>
  );
}
